import { useUpdateObjectDataRecordMutation } from '@redux/api'

export const useUpdateObjectDataRecordWithFixedKey = (globalId: string) => {
  return useUpdateObjectDataRecordMutation({
    fixedCacheKey: `update-object-data-record-${globalId}`,
  })
}
